import API from "@utils/request";
let Language = localStorage.getItem('currentLanguage');  //获取本地语言
let prout = 'protal';
if (!Language || Language == 'zh') {
    prout = 'protal';
} else {
    prout = 'protal_' + Language;
}
// 话题主持人-待办列表-第一层区域
export async function getHostDealtAreaLv1List(params) {
    try {
        return await API.post("/api/" + prout + "/api/host/getAreaLv1", params);
    } catch (error) {
        return error;
    }
}
// 话题主持人-待办列表-第二层区域
export async function getHostDealtAreaLv2List(params) {
    try {
        return await API.post("/api/" + prout + "/api/host/getAreaLv2", params);
    } catch (error) {
        return error;
    }
}
// 话题主持人-待办列表
export async function getHostDealtList(params) {
    try {
        return await API.post("/api/" + prout + "/api/host/dealtList", params);
    } catch (error) {
        return error;
    }
}
// 话题主持人-置顶
export async function setHostTopUp(params) {
    try {
        return await API.post("/api/" + prout + "/api/host/topUp", params);
    } catch (error) {
        return error;
    }
}
// 话题主持人-置精华
export async function setHostEssence(params) {
    try {
        return await API.post("/api/" + prout + "/api/host/setEssence", params);
    } catch (error) {
        return error;
    }
}
// 话题主持人-审核
export async function setHostAudit(params) {
    try {
        return await API.post("/api/" + prout + "/api/host/audit", params);
    } catch (error) {
        return error;
    }
}
// 话题主持人-删除
export async function setHostDelete(params) {
    try {
        return await API.post("/api/" + prout + "/api/host/delete", params);
    } catch (error) {
        return error;
    }
}

